<br>
<br>
<div class="col-md-5"><b>NYA INSTITUTIONER PER ÅR</b></div>
<br>
<div class="col-md-5">
  <form [formGroup]="agedistributionform">
    <mat-expansion-panel class="accordionmargin" [expanded]=true>
      <mat-expansion-panel-header [expandedHeight]="'48px'">
        <mat-panel-title>
          Sökparametrar
        </mat-panel-title>
        <mat-panel-description>
        </mat-panel-description>
      </mat-expansion-panel-header>
      <div class="form-group col-md-2">
        <label for="year">År
          <i *ngIf="yearlist?.length > 0" class="fa fa-circle" aria-hidden="true" style="color:green;" (change)="setToYears()"></i>
        </label>
        <select class="form-control form-control-sm" id="year" formControlName="year" (change)="addYear()">
          <option></option>
          <option *ngFor="let y of yearlist" [ngValue]="y">{{y}}</option>
        </select>
      </div>
    </mat-expansion-panel>
  </form>
</div>